import { useSearchAutocompleteMulti } from 'hooks/search'
import { graphql } from 'react-relay'
import { useSkillAutocomplete_Query } from '__generated__/useSkillAutocomplete_Query.graphql'
import { arrayFilterNonNullable } from 'services/array'

export function useSkillsAutocomplete(industryIds?: string[]) {
  const searchByIndustry = (search: string) => ({
    search,
    industryIds: industryIds || [],
  })

  // TODO: use a smaller page size here and fix scroll jumping
  return useSearchAutocompleteMulti<useSkillAutocomplete_Query>(graphql`
    query useSkillAutocomplete_Query($search: String, $industryIds: [ID!], $after: String) {
      skills(search: $search, industryIds: $industryIds, after: $after, first: 2000) {
        edges {
          node {
            id
            name
          }
        } 
        pageInfo {
          endCursor
        }
      }
    }
  `,
  searchByIndustry,
  results => results.skills?.edges?.map(e => e?.node?.name ? { label: e.node.name, value: e.node.id } : null)?.filter(arrayFilterNonNullable) || [],
  {
    extractCursor: results => results?.skills?.pageInfo?.endCursor,
    fetchKey: industryIds?.join(','),
  })
}
